import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { baseURL } from "utilities/variables";
import MenuTemplate from "../../templates/menuTemplate/menuTemplate";
import "./menu.scss";
const Menu = () => {
  const navigate = useNavigate();
  /*const tramitesDatos =
    [{title: "¿Cómo aplicar a doble titulación? 1", description: "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English.",buttonText1: "Ver trámites y preguntas frecuentes",buttonText2: "Soy un botón opcional", resumeTitle: "Trámitestestestes 1"}
    ,{title: "¿Cómo aplicar a doble titulación? 2", description: "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English.",buttonText1: "Ver trámites y preguntas frecuentes",resumeTitle: "Trámites 2" }
    ,{title: "¿Cómo aplicar a doble titulación? 3", description: "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English.",buttonText1: "Ver trámites y preguntas frecuentes",resumeTitle: "Trámites 3" }
    ,{title: "¿Cómo aplicar a doble titulación? 4", description: "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English.",buttonText1: "Ver trámites y preguntas frecuentes",resumeTitle: "Trámites 4" }
    ,{title: "¿Cómo aplicar a doble titulación? 5", description: "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English.",buttonText1: "Ver trámites y preguntas frecuentes",buttonText2: "Soy un botón opcional", resumeTitle: "Trámites 5" }
    ,{title: "¿Cómo aplicar a doble titulación? 6", description: "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English.",buttonText1: "Ver trámites y preguntas frecuentes",buttonText2: "Soy un botón opcional", resumeTitle: "Trámites 6" }
    ,{title: "¿Cómo aplicar a doble titulación? 7", description: "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English.",buttonText1: "Ver trámites y preguntas frecuentes",buttonText2: "Soy un botón opcional", resumeTitle: "Trámites 7" }
    ,{title: "¿Cómo aplicar a doble titulación? 8", description: "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English.",buttonText1: "Ver trámites y preguntas frecuentes", resumeTitle: "Trámites 8" }]
*/
  /*const BienestarDatos =
    [{title: "¿Cómo aplicar a doble titulación? 1", tag: "noticias", description: "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English.",buttonText1: "Ver trámites y preguntas frecuentes",buttonText2: "Soy un botón opcional", resumeTitle: "Trámitestestestes 1"}
    ,{title: "¿Cómo aplicar a doble titulación? 2", tag: "pregrado", description: "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English.",buttonText1: "Ver trámites y preguntas frecuentes",resumeTitle: "Trámites 2" }
    ,{title: "¿Cómo aplicar a doble titulación? 3", tag: "noticias", description: "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English.",buttonText1: "Ver trámites y preguntas frecuentes",resumeTitle: "Trámites 3" }
    ,{title: "¿Cómo aplicar a doble titulación? 4", tag: "noticias", description: "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English.",buttonText1: "Ver trámites y preguntas frecuentes",resumeTitle: "Trámites 4" }
    ,{title: "¿Cómo aplicar a doble titulación? 5", tag: "noticias", description: "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English.",buttonText1: "Ver trámites y preguntas frecuentes",buttonText2: "Soy un botón opcional", resumeTitle: "Trámites 5" }
    ,{title: "¿Cómo aplicar a doble titulación? 6", tag: "noticias", description: "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English.",buttonText1: "Ver trámites y preguntas frecuentes",buttonText2: "Soy un botón opcional", resumeTitle: "Trámites 6" }
    ,{title: "¿Cómo aplicar a doble titulación? 7", tag: "noticias", description: "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English.",buttonText1: "Ver trámites y preguntas frecuentes",buttonText2: "Soy un botón opcional", resumeTitle: "Trámites 7" }
    ,{title: "¿Cómo aplicar a doble titulación? 8", tag: "noticias", description: "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English.",buttonText1: "Ver trámites y preguntas frecuentes", resumeTitle: "Trámites 8" }]
*/
  const LaboratoriosDatos = [
    {
      title: "¿Cómo aplicar a doble titulación? 4",
      imgURL: "lab1.jpg",
      tag: "noticias",
      description:
        "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English.",
      buttonText1: "Ver trámites y preguntas frecuentes",
      buttonText2: "Soy un botón opcional",
      resumeTitle: "Trámitestestestes 1",
    },
    {
      title: "¿Cómo aplicar a doble titulación? 4",
      imgURL: "lab1.jpg",
      tag: "pregrado",
      description:
        "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English.",
      buttonText1: "Ver trámites y preguntas frecuentes",
      resumeTitle: "Trámites 2",
    },
    {
      title: "¿Cómo aplicar a doble titulación? 4",
      imgURL: "lab2.jpg",
      tag: "noticias",
      description:
        "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English.",
      buttonText1: "Ver trámites y preguntas frecuentes",
      resumeTitle: "Trámites 3",
    },
    {
      title: "¿Cómo aplicar a doble titulación? 4",
      tag: "noticias",
      description:
        "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English.",
      buttonText1: "Ver trámites y preguntas frecuentes",
      resumeTitle: "Trámites 4",
    },
    {
      title: "¿Cómo aplicar a doble titulación? 5",
      tag: "noticias",
      description:
        "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English.",
      buttonText1: "Ver trámites y preguntas frecuentes",
      buttonText2: "Soy un botón opcional",
      resumeTitle: "Trámites 5",
    },
    {
      title: "¿Cómo aplicar a doble titulación? 6",
      tag: "noticias",
      description:
        "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English.",
      buttonText1: "Ver trámites y preguntas frecuentes",
      buttonText2: "Soy un botón opcional",
      resumeTitle: "Trámites 6",
    },
    {
      title: "¿Cómo aplicar a doble titulación? 4",
      imgURL: "lab1.jpg",
      tag: "noticias",
      description:
        "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English.",
      buttonText1: "Ver trámites y preguntas frecuentes",
      buttonText2: "Soy un botón opcional",
      resumeTitle: "Trámites 7",
    },
    {
      title: "¿Cómo aplicar a doble titulación? 4",
      imgURL: "lab2.jpg",
      tag: "noticias",
      description:
        "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English.",
      buttonText1: "Ver trámites y preguntas frecuentes",
      resumeTitle: "Trámites 8",
    },
  ];

  const [programasDatos, setProgramasDatos] = useState(undefined);
  const [laboratoriosDatos, setLaboratoriosDatos] = useState(undefined);
  const [tramitesDatos, setTramitesDatos] = useState(undefined);
  const [noticiasDatos, setNoticiasDatos] = useState(undefined);
  const [bienestarDatos, setBienestarDatos] = useState(undefined);
  const [comunidadDatos, setComunidadDatos] = useState(undefined);
  const [convocatorias, setConvocatorias] = useState(undefined);
  const [calendarioDatos, setCalendarioDatos] = useState([
    {
      date: "2022-11-20",
      title: "Evento de sede",
      events: ["Cierrre", "evento deportivo"],
      imgURL:
        "https://c4.wallpaperflare.com/wallpaper/867/119/831/arbol-naturaleza-roble-viejo-wallpaper-preview.jpg",
    },
    {
      date: "2022-06-20",
      title: "Evento de sede",
      events: ["Cierrre", "evento deportivo"],
      imgURL:
        "https://c4.wallpaperflare.com/wallpaper/867/119/831/arbol-naturaleza-roble-viejo-wallpaper-preview.jpg",
    },
    {
      date: "2022-07-20",
      title: "Evento de sede",
      events: ["Cierrre", "evento deportivo"],
      imgURL:
        "https://c4.wallpaperflare.com/wallpaper/867/119/831/arbol-naturaleza-roble-viejo-wallpaper-preview.jpg",
    },
    {
      date: "2022-04-20",
      title: "Evento de sede",
      events: ["Cierrre", "evento deportivo"],
      imgURL:
        "https://c4.wallpaperflare.com/wallpaper/867/119/831/arbol-naturaleza-roble-viejo-wallpaper-preview.jpg",
    },
    {
      date: "2022-04-20",
      title: "Evento de sede",
      events: ["Cierrre", "evento deportivo"],
      imgURL:
        "https://c4.wallpaperflare.com/wallpaper/867/119/831/arbol-naturaleza-roble-viejo-wallpaper-preview.jpg",
    },
    {
      date: "2022-04-20",
      title: "Evento de sede",
      events: ["Cierrre", "evento deportivo"],
      imgURL:
        "https://c4.wallpaperflare.com/wallpaper/867/119/831/arbol-naturaleza-roble-viejo-wallpaper-preview.jpg",
    },
  ]);
  //Deben seguir este orden:
  /*const MenuOptions = ["Comunidad universitaria" ,"Convocatorias","Bienestar universitario","Calendario académico" ,"Noticias y eventos" ,"Laboratorios" ,"Trámites y preguntas","Programas ofertados"]*/
  const [data, setData] = useState([
    comunidadDatos,
    convocatorias,
    bienestarDatos,
    calendarioDatos,
    laboratoriosDatos,
    laboratoriosDatos,
    tramitesDatos,
    programasDatos,
  ]);
  useEffect(() => {
    let auxData = [
      comunidadDatos,
      convocatorias,
      bienestarDatos,
      calendarioDatos,
      noticiasDatos,
      laboratoriosDatos,
      tramitesDatos,
      programasDatos,
    ];
    setData(auxData);
  }, [
    comunidadDatos,
    convocatorias,
    laboratoriosDatos,
    tramitesDatos,
    noticiasDatos,
    bienestarDatos,
  ]);
  useEffect(() => {
    //Datos de los programas ofertados
    axios
      .get(
        baseURL +
          "/api/programas-ofertados?fields=titulo,descripcion&populate=imagenPrincipal.imagen,nivelFormacion"
      )
      .then((response) => {
        //Darle un formato más sencillo a los datos:
        let auxData = response.data.data;
        let auxEasyData = [];
        auxData.map((value) => {
          let descripcion = value.attributes.descripcion.substring(0, 300);
          descripcion =
            descripcion.substring(0, descripcion.lastIndexOf(" ")) + "...";
          auxEasyData.push({
            title: value.attributes.titulo,
            description: descripcion,
            tag: value.attributes.nivelFormacion.tipo.toLowerCase(),
            imgURL: `${baseURL}${value.attributes.imagenPrincipal.imagen.data.attributes.url}`,
            buttonText1: "Ver programa",
            buttonText2: "Ver todos los programas",
            alt: value.attributes.imagenPrincipal.imagen.data.attributes
              .alternativeText,
            id: value.id,
            handle1: () => {
              navigate(`/programa/${value.id}/perfil`);
            },
            handle2: () => {
              navigate("/programas");
            },
            //tag: value.attributes.nivelFormacion.tipo
          });
        });
        setProgramasDatos(auxEasyData);
      });
    //Datos de los laboratorios
    axios
      .get(baseURL + "/api/lista-laboratorios?populate=imagenPrincipal.imagen")
      .then((response) => {
        let auxData = response.data.data;
        let auxEasyData = [];
        auxData.map((value) => {
          let descripcion = value.attributes.descripcion.substring(0, 300);
          descripcion =
            descripcion.substring(0, descripcion.lastIndexOf(" ")) + "...";
          auxEasyData.push({
            title: value.attributes.titulo,
            description: descripcion,
            imgURL: `${baseURL}${value.attributes.imagenPrincipal.imagen.data.attributes.url}`,
            buttonText1: "Ver más",
            buttonText2: "Ver todos los laboratorios",
            alt: value.attributes.imagenPrincipal.imagen.data.attributes
              .alternativeText,
            id: value.id,
            handle1: () => {
              window.open(value.attributes.url);
            },
            handle2: () => {
              navigate(`/laboratorios`);
            },
          });
        });
        setLaboratoriosDatos(auxEasyData);
      });
    //Datos de Noticias y eventos
    axios
      .get(
        baseURL +
          "/api/menu-rotativo-noticias-y-evento?populate=secciones.imagen.imagen%2C%20secciones.boton"
      )
      .then((response) => {
        let auxData = response.data.data.attributes.secciones;
        let auxEasyData = [];
        auxData.map((value) => {
          let descripcion = value.descripcion.substring(0, 300);
          descripcion =
            descripcion.substring(0, descripcion.lastIndexOf(" ")) + "...";
          auxEasyData.push({
            title: value.titulo,
            tag: value.etiqueta.toLowerCase(),
            description: descripcion,
            imgURL: `${baseURL}${value.imagen.imagen.data.attributes.url}`,
            buttonText1: value.boton.textoBoton,
            handle1: () => {
              window.open(value.boton.enlace);
            },
          });
        });
        setNoticiasDatos(auxEasyData);
      });

    //Datos de Bienestar Universitario
    axios
      .get(
        baseURL +
          "/api/menu-rotativo-bienestar-universitario?populate=secciones.imagen.imagen%2C%20secciones.boton"
      )
      .then((response) => {
        let auxData = response.data.data.attributes.secciones;

        let auxEasyData = [];
        auxData.map((value) => {
          let descripcion = value.descripcion.substring(0, 300);
          descripcion =
            descripcion.substring(0, descripcion.lastIndexOf(" ")) + "...";
          auxEasyData.push({
            title: value.titulo,
            description: descripcion,
            imgURL: `${baseURL}${value.imagen.imagen.data.attributes.url}`,
            buttonText1: value.boton.textoBoton,
            handle1: () => window.open(value.boton.enlace),
          });
        });
        setBienestarDatos(auxEasyData);
      });

    //Datos de Calendario Académico
    axios
      .get(
        baseURL +
          "/api/menu-rotativo-calendario?populate=eventos.imagen%2C%20eventos.eventos"
      )
      .then((response) => {
        let auxData = response.data.data.attributes.eventos;

        let auxEasyData = [];
        auxData.map((value) => {
          let auxObject = { date: "", title: "", events: [], imgURL: "" };
          auxObject.date = value.fecha;
          auxObject.title = value.tituloEventos;
          value.eventos.map((event) => {
            auxObject.events.push(event.nombre);
          });
          auxObject.imgURL = `${baseURL}${value.imagen.data.attributes.url}`;
          auxEasyData.push(auxObject);
        });
        setCalendarioDatos(auxEasyData);
      });

    //Datos de Convocatorias
    axios
      .get(
        baseURL +
          "/api/menu-rotativo-convocatoria?populate=imagen.imagen%2Cconvocatorias%2Cboton"
      )
      .then((response) => {
        let auxData = response.data.data.attributes;
        let auxEasyData = [];
        let descripcion = auxData.descripcion.substring(0, 300);
        descripcion =
          descripcion.substring(0, descripcion.lastIndexOf(" ")) + "...";
        auxEasyData.push({
          title: auxData.titulo,
          description: descripcion,
          imgURL: `${baseURL}${auxData.imagen.imagen.data.attributes.url}`,
          buttonText1: auxData.boton.textoBoton,
          handle1: () => {
            window.open(auxData.boton.enlace);
          },
          flags: auxData.convocatorias,
        });
        setConvocatorias(auxEasyData);
      });
    //Datos de Comunidad universitaria
    axios
      .get(
        baseURL +
          "/api/menu-rotativo-comunidad-universitaria?populate=estudiantes.cartas%2Cdocentes.cartas%2Cadministrativos.cartas%2C%20egresados.cartas"
      )
      .then((response) => {
        let auxResponse = response.data.data.attributes;

        let auxData = {};
        auxData.estudiantes = auxResponse.estudiantes;
        auxData.docentes = auxResponse.docentes;
        auxData.egresados = auxResponse.egresados;
        auxData.administrativos = auxResponse.administrativos;
        setComunidadDatos(auxData);
      });
    //Datos de tramites:
    axios
      .get(
        baseURL +
          "/api/tramites?populate=acordeones&populate=imagenPrincipal.imagen"
      )
      .then((response) => {
        let auxData = response.data.data;
        let auxEasyData = [];
        auxData.map((value) => {
          let descripcion = value.attributes.descripcionResumen;
          descripcion =
            descripcion.substring(0, descripcion.lastIndexOf(" ")) + "...";
          auxEasyData.push({
            domain: value.attributes.dominio,
            title: value.attributes.titulo,
            description: descripcion,
            imgURL: `${baseURL}${value.attributes.imagenPrincipal.imagen.data.attributes.url}`,
            alt: value.attributes.imagenPrincipal.imagen.data.attributes
              .alternativeText,
            buttonText1: "Ver trámite",
            buttonText2: "Ver trámites y preguntas frecuentes",

            handle1: () => {
              navigate(`/tramites/${value.attributes.dominio}`);
            },
            handle2: () => {
              navigate(`/tramites/`);
            },
            //tag: value.attributes.nivelFormacion.tipo
          });
        });
        setTramitesDatos(auxEasyData);
      });
  }, []);
  return (
    <div className="menu__main-container">
      <MenuTemplate contentData={data} />
    </div>
  );
};

export default Menu;
